export const PAYMENT_REGISTRATION_VIEW = 'PAYMENT_REGISTRATION_VIEW';
export const REGISTRATION_COMPLETION = 'REGISTRATION_COMPLETION';
